import React from 'react';
import {Route, Redirect, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Header from './header';
import Footer from './footer';

import {Home, Account, Cart, Course, CourseRegistration, Lesson, Level, PaymentResult, ImageSlide, VideoPlayer} from 'pages/app';

import {
    Main as AdminMain,
    Level as AdminLevel,
    Bills as AdminBills,
    BillDetail as AdminBillDetail,
    CourseManagement,
    CourseDetailManagement,
    LessonManagement,
    LessonDetailManagement,
    LessonSettingManagement,
    LevelManagement,
    LevelSettingManagement
} from 'pages/admin';

import {UserApi} from 'services/network/api';
import {checkUserExist} from 'services/user';
import {LocaleAction, RouterAction} from 'services/redux/actions';

class AppContainer extends React.Component {
    constructor(props) {
        super(props);

        this.checkAuth();
        this.getUserLocale();

        this.props.history.listen((location, action) => {
            let {router} = this.props;
            const id = router && router.length > 0 ? router.sort((a, b) => b.id - a.id)[0].id + 1 : 1;
            if (router && router.length > 0) {
                if (router.sort((a, b) => b.id - a.id)[0].location.pathname != location.pathname) {
                    const history = Object.assign({}, {id}, {location}, {action});
                    router.push(history);
                }
            }
            if (router.length == 0) {
                const history = Object.assign({}, {id}, {location}, {action});
                router.push(history);
            }
        });

    }

    checkAuth() {
        const userExist = checkUserExist();

        if (!userExist)
            return '/register/register';

        if (window.location.hash.includes('app/'))
            return window.location.hash.replace('#', '');

        const {match} = this.props;
        return `${match.url}/home`;
    }

    getUserLocale() {
        UserApi.GetLocale()
            .then(res => {
                if (res && res.status == 200) {
                    const {actions} = this.props;
                    if (typeof (res.data.translation == 'string'))
                        res.data.translation = JSON.parse(res.data.translation);

                    actions.setLocale(res.data);
                }
            })
    };

    render() {
        const {match, locale} = this.props;

        const renderStyle = () => {
            return (
                <link rel="stylesheet" type="text/css"
                      href={locale && locale.rtl ? './assets/styles/rtl.css' : './assets/styles/ltr.css'}/>
            )
        };

        return (
            <div>
                <Header/>
                {renderStyle()}
                <div className='main-container' style={{minHeight: '85vh'}}>
                    <Redirect exact from={`${match.url}`} to={this.checkAuth()}/>
                    <Route path={`${match.url}/home`}>
                        <Home/>
                    </Route>
                    <Route path={`${match.url}/account`}>
                        <Account/>
                    </Route>
                    <Route path={`${match.url}/cart`}>
                        <Cart/>
                    </Route>
                    <Route path={`${match.url}/courseRegistration`}>
                        <CourseRegistration/>
                    </Route>
                    <Route path={`${match.url}/course`}>
                        <Course/>
                    </Route>
                    <Route path={`${match.url}/lesson`}>
                        <Lesson/>
                    </Route>
                    <Route path={`${match.url}/level`}>
                        <Level/>
                    </Route>
                    <Route path={`${match.url}/paymentResult`}>
                        <PaymentResult/>
                    </Route>
                    <Route path={`${match.url}/imageSlide`}>
                        <ImageSlide/>
                    </Route>
                    <Route path={`${match.url}/videoPlayer`}>
                        <VideoPlayer/>
                    </Route>

                    {/*Admin Pages*/}
                    <Route path={`${match.url}/admin/main`}>
                        <AdminMain/>
                    </Route>
                    <Route path={`${match.url}/admin/level`}>
                        <AdminLevel/>
                    </Route>
                    <Route path={`${match.url}/admin/bills`}>
                        <AdminBills/>
                    </Route>
                    <Route path={`${match.url}/admin/billDetail`}>
                        <AdminBillDetail/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/course`}>
                        <CourseManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/courseDetail`}>
                        <CourseDetailManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/lesson`}>
                        <LessonManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/lessonDetail`}>
                        <LessonDetailManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/lessonSetting`}>
                        <LessonSettingManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/level`}>
                        <LevelManagement/>
                    </Route>
                    <Route path={`${match.url}/admin/cms/levelSetting`}>
                        <LevelSettingManagement/>
                    </Route>
                </div>

                <Footer/>
            </div>
        );
    }
}


const ActionCreators = Object.assign({}, LocaleAction, RouterAction);

const mapDispatchToProps = dispatch => {
    return ({
        actions: bindActionCreators(ActionCreators, dispatch)
    });
};

const mapStateToProps = state => {
    const {locale, router} = state;
    return {locale, router};
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppContainer));

